/**
 * Small styled form primitives for the mail feature (the repo has no shared
 * `<Input>`/`<Textarea>` component — raw elements with the token classes are the
 * house style). Kept theme-aware (uses `bg-background`/`border-input`/`ring`).
 */
import { type ComponentProps, type JSX, Show, splitProps } from "solid-js";
import { cn } from "@cartero/shared";

const fieldInputClass =
  "w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 transition-shadow";

export function MailInput(props: ComponentProps<"input">) {
  const [local, rest] = splitProps(props, ["class"]);
  return <input class={cn(fieldInputClass, local.class)} {...rest} />;
}

export function MailTextarea(props: ComponentProps<"textarea">) {
  const [local, rest] = splitProps(props, ["class"]);
  return <textarea class={cn(fieldInputClass, "min-h-32 resize-y", local.class)} {...rest} />;
}

export function Field(props: { label: string; children: JSX.Element; hint?: string }) {
  return (
    <label class="flex flex-col gap-1.5">
      <span class="text-xs font-medium text-muted-foreground">{props.label}</span>
      {props.children}
      <Show when={props.hint}>
        <span class="text-[11px] text-muted-foreground/70">{props.hint}</span>
      </Show>
    </label>
  );
}
